/*
    © 2022 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Ajax 'Add To Cart' (ATC) forms
window.onSubmitAtcForm = async (form, event) => {
    event.preventDefault()

    const btn = form.querySelector('button[name="add"]')
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })

    btn.innerHTML = window.themeStrings.addToCart

    const isActiveSubscriber = btn.dataset.isActiveSubscriber
    const discountCode = btn.dataset.discountCode

    console.log(isActiveSubscriber)

    if (discountCode && discountCode.length && isActiveSubscriber === 'true') {
        setTimeout(() => {
            if (discountCode && discountCode.length) {
                window.DiscountHero.discount.apply(discountCode)
            }
        }, 1000)
    }

    if (document.querySelector('#offcanvas-cart')) {
        bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show()
    }

    window.refreshCartContents()
}

// Product Options - listen for onchange events
window.onChangeProductOption = async (input) => {
    const productWrapper = input.closest('.product')
    const addToCartBtn = productWrapper.querySelector('[name="add"]')

    const response = await fetch(`/products/${input.dataset.productHandle}.js`)
    const productData = await response.json()

    const productOptions = []

    productWrapper.querySelectorAll('.product-option').forEach(el => {
        productOptions.push(el.value)
    })

    const selectedVariant = productData.variants.find(variant =>
        variant.title.includes(productOptions.toString().replace(',', ' / '))
    )

    console.log(selectedVariant)

    if (selectedVariant) {
        productWrapper.querySelector('[name="id"]').value = selectedVariant.id

        if (selectedVariant.available) {
            addToCartBtn.disabled = false
            addToCartBtn.innerHTML = window.themeStrings.addToCart
        } else {
            addToCartBtn.disabled = true
            addToCartBtn.innerHTML = window.themeStrings.soldOut
        }

        if (selectedVariant.compare_at_price) {
            productWrapper.querySelector('.product-price-compare').style.display = 'inline-block'
            productWrapper.querySelector('.product-price-compare s').textContent = window.formatMoney(selectedVariant.compare_at_price)
            productWrapper.querySelector('.product-price-final').classList.add('text-success')
            productWrapper.querySelector('.product-price-final').textContent = window.formatMoney(selectedVariant.price)
        } else {
            productWrapper.querySelector('.product-price-compare').style.display = 'none'
            productWrapper.querySelector('.product-price-compare s').textContent = ''
            productWrapper.querySelector('.product-price-final').classList.remove('text-success')
            productWrapper.querySelector('.product-price-final').textContent = window.formatMoney(selectedVariant.price)
        }

        bootstrap.Carousel.getOrCreateInstance('#product-carousel')
            ?.to(selectedVariant.featured_media.position - 1)

        const url = new URL(window.location)
        url.searchParams.set('variant', selectedVariant.id)
        window.history.replaceState({}, '', url)
    } else {
        addToCartBtn.disabled = true
        addToCartBtn.innerHTML = window.themeStrings.unavailable
    }
}

// Anual Membership Checkout Button
window.onClickAnnualMembershipBtn = async (btn, event) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            items: [{
                id: Number(btn.dataset.variantId),
                quantity: Number(btn.dataset.quantity),
                selling_plan: Number(btn.dataset.sellingPlanId)
            }]
        })
    })

    window.location.href = '/checkout'
}

// Product Carousel - Sticky position on scroll (only desktop)
const productCarousel = document.querySelector('#product-carousel.sticky-top')
if (productCarousel) {
    const navbarHeight = document.querySelector('#shopify-section-navbar.sticky-top').clientHeight || 0
    productCarousel.style.top = `${navbarHeight + 20}px`
    productCarousel.style.zIndex = '1'
}

// Product Media Gallery - Init Splide
const initProductMediaGalleryMobile = () => {
    const elem = document.querySelector('#product-media-gallery-mobile')

    if (!elem) { return }

    const main = new Splide(elem.querySelector('.splide-main'), {
        type: 'loop',
        pagination: false,
        arrows: false,
        gap: '1rem',
        padding: { left: '3rem', right: '3rem' },
        mediaQuery: 'min'
    })

    main.mount()
}
initProductMediaGalleryMobile()

const initProductMediaGalleryDesktop = () => {
    const elem = document.querySelector('#product-media-gallery-desktop')

    if (!elem) { return }

    const main = new Splide(elem.querySelector('.splide-main'), {
        type: 'slide',
        rewind: true,
        pagination: false,
        arrows: false
    })

    const thumbs = new Splide(elem.querySelector('.splide-thumbs'), {
        gap: 12,
        rewind: true,
        arrows: true,
        pagination: false,
        perPage: 5,
        isNavigation: true,
        breakpoints: {
            575: {
                perPage: 3
            }
        }
    })

    main.sync(thumbs)
    main.mount()
    thumbs.mount()
}
initProductMediaGalleryDesktop()
